import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=da80d512&"
import script from "./base-dialog.vue?vue&type=script&lang=js&"
export * from "./base-dialog.vue?vue&type=script&lang=js&"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=da80d512&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports